import { render, staticRenderFns } from "./CandidatoForm.vue?vue&type=template&id=adc11a9c"
import script from "./CandidatoForm.vue?vue&type=script&lang=js"
export * from "./CandidatoForm.vue?vue&type=script&lang=js"
import style0 from "./CandidatoForm.vue?vue&type=style&index=0&id=adc11a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports